import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFreshdeskContextState } from 'store';

const useEntityTableColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getUiControlsConfigs } = useFreshdeskContextState();
  const columnControls = useMemo(() => getUiControlsConfigs()?.entityList?.table?.columns ?? {}, [getUiControlsConfigs]);

  return useMemo(() => {
    const columns = [
      {
        key: 'icon',
        text: t('entities.headers.icon'),
        variant: 'icon',
        textAlign: 'center',
        widthProperties: {
          width: '120px',
        },
      },
      {
        key: 'name',
        text: t('entities.headers.objectName'),
        widthProperties: {
          width: '150px',
        },
        customTemplate: (createElement, { href, text }) => {
          return createElement(
            'a',
            {
              style: {
                color: '#2C5CC5',
                textDecoration: 'none',
                fontWeight: '600',
                cursor: 'pointer',
              },
              onClick: e => {
                e.preventDefault();
                navigate(href);
              },
            },
            text
          );
        },
      },
      {
        key: 'description',
        text: t('entities.headers.description'),
        widthProperties: {
          width: '500px',
          overflow: 'hidden',
          wordWrap: 'break-word',
        },
      },
      {
        key: 'associated_objects',
        text: t('entities.headers.relatedObjects'),
        widthProperties: {
          width: '300px',
        },
      },
      {
        key: 'created_time',
        text: t('entities.headers.createdAt'),
        widthProperties: {
          width: '164px',
        },
      },
    ];

    return columns
      .filter(column => columnControls[column.key]?.visible !== false)
      .map(column => {
        const overrides = columnControls[column.key];
        if (overrides?.widthProperties) {
          return {
            ...column,
            widthProperties: { ...column.widthProperties, ...overrides.widthProperties },
          };
        }
        return column;
      });
  }, [t, navigate, columnControls]);
};

export default useEntityTableColumns;
